import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "kmt-storefinder__list" }
const _hoisted_2 = {
  key: 0,
  class: "kmt-storefinder__list__wrapper__legend"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_4 = {
  class: "kmt-storefinder__list__wrapper__inner",
  ref: "listInnerElement"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  class: "kmt-storefinder__list__scroll",
  ref: "scroll"
}
const _hoisted_8 = { class: "kmt-storefinder__list__message" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_location_search = _resolveComponent("location-search")!
  const _component_location_filter = _resolveComponent("location-filter")!
  const _component_store_list_item = _resolveComponent("store-list-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["kmt-storefinder__list__wrapper", [_ctx.isCenteredMapCSSClass]]),
      ref: "listElement"
    }, [
      (_ctx.resultTypes.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultTypes, (resultType) => {
              return (_openBlock(), _createElementBlock("span", {
                key: resultType.key,
                class: _normalizeClass(resultType.key)
              }, [
                _hoisted_3,
                _createTextVNode(" " + _toDisplayString(resultType.label), 1)
              ], 2))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", {
          innerHTML: _ctx.translationComposition.headlineTranslation
        }, null, 8, _hoisted_5),
        _createElementVNode("p", {
          innerHTML: _ctx.translationComposition.introTranslation
        }, null, 8, _hoisted_6),
        _createVNode(_component_location_search, {
          onOnSubmit: _ctx.onSearchSubmit,
          onOnGeolocationChange: _ctx.onGeolocationChange,
          ref: "search"
        }, null, 8, ["onOnSubmit", "onOnGeolocationChange"]),
        (_ctx.isFilterEnabled)
          ? (_openBlock(), _createBlock(_component_location_filter, {
              key: 0,
              onReset: _cache[0] || (_cache[0] = ($event: any) => (this.$refs.search.reset())),
              ref: "filter"
            }, null, 512))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_ctx.geolocationComposition.isAutocompleteLoading)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.translationComposition.infoLoadingTranslation), 1))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.hasAllStores)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        innerHTML: _ctx.infoAllStoresTranslation
                      }, null, 8, _hoisted_10))
                    : _createCommentVNode("", true),
                  (_ctx.hasRestrictedStores)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 1,
                        innerHTML: _ctx.infoRestrictedStoresTranslation
                      }, null, 8, _hoisted_11))
                    : _createCommentVNode("", true),
                  (_ctx.hasNoStores)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 2,
                        innerHTML: _ctx.infoNoStoresTranslation
                      }, null, 8, _hoisted_12))
                    : _createCommentVNode("", true),
                  (_ctx.hasNoSuggestResults)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 3,
                        innerHTML: _ctx.noSuggestResultsTranslation
                      }, null, 8, _hoisted_13))
                    : _createCommentVNode("", true),
                  (_ctx.hasNoSuggestSelection)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 4,
                        innerHTML: _ctx.translationComposition.noSuggestSelectionTranslation
                      }, null, 8, _hoisted_14))
                    : _createCommentVNode("", true)
                ], 64))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeComposition.stores, (store) => {
            return (_openBlock(), _createBlock(_component_store_list_item, {
              key: `${store.uid}${store.Entfernung}${_ctx.geolocationComposition.positionHash}`,
              store: store,
              onActivate: _ctx.onActivate,
              onDeactivate: _ctx.onDeactivate,
              onOpen: _ctx.onOpen
            }, null, 8, ["store", "onActivate", "onDeactivate", "onOpen"]))
          }), 128))
        ], 512)
      ], 512)
    ], 2)
  ]))
}